export default __webpack_public_path__ + "static/ChatIcon-2d09bdbebff5d481ad4acb4e35a0f8cf.webp";